import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function splitWords(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach(textNode => {
        const parts = textNode.textContent.split(/(\s+)/);
        const frag = document.createDocumentFragment();
        parts.forEach(part => {
            if (/\S/.test(part)) {
                const span = document.createElement('span');
                span.className = 'home-section-two__word';
                span.textContent = part;
                frag.appendChild(span);
            } else {
                frag.appendChild(document.createTextNode(part));
            }
        });
        textNode.parentNode.replaceChild(frag, textNode);
    });
}

const section = document.querySelector('.home-section-two');

if (section) {
    const textEl = section.querySelector('.home-section-two__text');
    splitWords(textEl);

    const words = section.querySelectorAll('.home-section-two__word');

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: 'top 70%',
            end: 'bottom 30%',
            scrub: 0.5,
        },
    });

    tl.fromTo(
        words,
        { color: 'rgba(185, 152, 92, 0.50)' },
        {
            color: 'rgba(27, 30, 54, 1)',
            stagger: { each: 0.1, ease: 'none' },
            ease: 'none',
            duration: 0.5,
        }
    );
}
